import { Dispatch, ReactNode, SetStateAction } from 'react';

import { EDestinationSwitcher } from '@/src/components/cross-sale/useCrossSale';

interface IProps {
  mostPopularText: string | null;
  allDestinationsText: string | null;
  zonesText: string | null;
  subTitle: ReactNode | null;
  inverted?: boolean;
  setDestinationTypeSwitcher: Dispatch<SetStateAction<EDestinationSwitcher>>;
  destinationTypeSwitcher: EDestinationSwitcher;
}

export const CrossSaleDestinationSwitcher = ({
  mostPopularText,
  allDestinationsText,
  zonesText,
  subTitle,
  setDestinationTypeSwitcher,
  destinationTypeSwitcher,
}: IProps) => {
  const classNameActive =
    'rounded-5xl justify-center p-4 text-center active:text-white font-semibold bg-primary active:bg-primary-dark text-white flex items-center';
  const classNameInactive =
    'cursor-pointer rounded-4xl justify-center p-4 text-center active:text-white font-semibold bg-transparent active:bg-primary-dark text-black flex items-center';

  return (
    <>
      <div
        className={
          'mx-auto mb-10 flex flex-col items-center justify-center gap-8'
        }
      >
        <div className={'grid grid-cols-3 rounded-5xl bg-overlay p-0.5'}>
          {destinationTypeSwitcher === EDestinationSwitcher.MOST_POPULAR && (
            <>
              <button className={classNameActive}>{mostPopularText}</button>
              <button
                className={classNameInactive}
                onClick={() =>
                  setDestinationTypeSwitcher(
                    EDestinationSwitcher.ALL_DESTINATIONS
                  )
                }
              >
                {allDestinationsText}
              </button>
              <button
                className={classNameInactive}
                onClick={() =>
                  setDestinationTypeSwitcher(EDestinationSwitcher.ZONES)
                }
              >
                {zonesText}
              </button>
            </>
          )}
          {destinationTypeSwitcher ===
            EDestinationSwitcher.ALL_DESTINATIONS && (
            <>
              <button
                className={classNameInactive}
                onClick={() =>
                  setDestinationTypeSwitcher(EDestinationSwitcher.MOST_POPULAR)
                }
              >
                {mostPopularText}
              </button>
              <button className={classNameActive}>{allDestinationsText}</button>
              <button
                className={classNameInactive}
                onClick={() =>
                  setDestinationTypeSwitcher(EDestinationSwitcher.ZONES)
                }
              >
                {zonesText}
              </button>
            </>
          )}
          {destinationTypeSwitcher === EDestinationSwitcher.ZONES && (
            <>
              <button
                className={classNameInactive}
                onClick={() =>
                  setDestinationTypeSwitcher(EDestinationSwitcher.MOST_POPULAR)
                }
              >
                {mostPopularText}
              </button>
              <button
                className={classNameInactive}
                onClick={() =>
                  setDestinationTypeSwitcher(
                    EDestinationSwitcher.ALL_DESTINATIONS
                  )
                }
              >
                {allDestinationsText}
              </button>
              <button className={classNameActive}>{zonesText}</button>
            </>
          )}
        </div>
      </div>
      <div className={'pb-2 text-center text-3xl font-semibold'}>
        {subTitle}
      </div>
    </>
  );
};
